import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import {
  SideBarSignalState,
  SideBarStore,
  SideBarThreadAnchor,
} from '@data-access/shared';
import { computed, Type, ViewContainerRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';

export const HANDLE_SIDE_BAR_SIGNAL_STORE = signalStore(
  withState<SideBarStore>(() => ({
    currentComponentRef: null,
    currentViewContainerRef: null,
    requestedComponent: null,
    toggleSideBar: false,
  })),
  withProps((store) => ({
    store,
  })),
  withComputed(
    ({
      currentViewContainerRef,
      currentComponentRef,
      requestedComponent,
      toggleSideBar,
    }) => ({
      $currentComponentRef: computed(() => currentComponentRef()),
      $currentViewContainerRef: computed(() => currentViewContainerRef()),
      $requestedComponent: computed(() => requestedComponent()),
      $toggleSideBar: computed(() => toggleSideBar()),
    }),
  ),
  withMethods(
    ({
      currentComponentRef,
      currentViewContainerRef,
      requestedComponent,
      ...store
    }) => ({
      clearCurrentComponentRef: () => {
        currentComponentRef()?.destroy();
        patchState(store, {
          currentComponentRef: null,
          requestedComponent: null,
        });
      },
      clearCurrentViewContainerRef: () => {
        currentComponentRef()?.destroy();
        patchState(store, {
          currentComponentRef: null,
          currentViewContainerRef: null,
          requestedComponent: null,
        });
      },
      setCurrentViewContainerComponent: (
        component: ComponentType<unknown>,
        anchor?: SideBarThreadAnchor,
      ) => {
        // Recorded before the host check: consumers that render the request
        // themselves (the Collab Hub drawer's tabs) never set a view container,
        // so gating this too would leave them with nothing to react to.
        patchState(store, {
          requestedComponent: component
            ? {
                anchor: anchor ?? null,
                component,
                seq: (requestedComponent()?.seq ?? 0) + 1,
              }
            : null,
        });
        if (currentViewContainerRef() && component) {
          currentViewContainerRef()?.clear();
          const _ref = currentViewContainerRef()?.createComponent(component);
          patchState(store, { currentComponentRef: _ref });
        }
      },
      setCurrentViewContainerRef: (vcr: ViewContainerRef) =>
        patchState(store, { currentViewContainerRef: vcr }),
      toggleSideBarOpen: (isOpen: boolean) =>
        patchState(store, { toggleSideBar: isOpen }),
    }),
  ),
) satisfies Type<SideBarSignalState>;
